import {
  UPDATE_PASSWORD,
  CREATE_ORGANIZER_USER,
  LIST_ORGANIZER_USER,
  GET_ORGANIZER_USER,
  INACTIVATE_ORGANIZER_PROFILE,
  ACTIVATE_ORGANIZER_PROFILE,
  UPDATE_ORGANIZER_PROFILE,
} from './config';

export async function updatePassword(role, oldPw, newPw) {
  const url = UPDATE_PASSWORD.replace('{role}', role);
  const token = localStorage.getItem('token');

  const result = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      password: newPw,
      oldPassword: oldPw,
    }),
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      return data;
    });

  return result;
}

export async function createOrganizerUser(data) {
  const url = CREATE_ORGANIZER_USER;
  const token = localStorage.getItem('token');

  const status = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
      //throw new Error('Error creating organizer user');
    })
    .then((data) => {
      return data;
    });

  return status;
}

export async function getOrganizerUsers() {
  const url = LIST_ORGANIZER_USER;
  const token = localStorage.getItem('token');

  const users = await fetch(url, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      return data;
    });

  return users;
}

export async function getOrganizerUser() {
  const url = GET_ORGANIZER_USER;
  const token = localStorage.getItem('token');

  const data = await fetch(url, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error('Could not get organizer profile');
      }
    })
    .then((data) => {
      let user = {
        id: data.profile?.id,
        email: data.profile?.email,
        clubName: data.organizer?.clubName,
        district: data.organizer?.district,
        logoUrl: data.organizer?.logoUrl,
        organizerAdmin: false,
      };
      return user;
    })
    .catch((text) => {
      console.log(text);
    });

  return data;
}

export async function inactivateOrganizerUser(organizerProfileId) {
  const url = INACTIVATE_ORGANIZER_PROFILE.replace(
    '{organizerProfileId}',
    organizerProfileId
  );
  const token = localStorage.getItem('token');

  const result = await fetch(url, {
    method: 'PUT',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error('Kunde inte inaktivera organizer profile');
      }
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      //console.error(err);
    });

  return result;
}

export async function activateOrganizerUser(organizerProfileId) {
  const url = ACTIVATE_ORGANIZER_PROFILE.replace(
    '{organizerProfileId}',
    organizerProfileId
  );
  const token = localStorage.getItem('token');

  const result = await fetch(url, {
    method: 'PUT',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error('Kunde inte aktivera organizer profile');
      }
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      //console.error(err);
    });

  return result;
}

export async function updateOrganizerUser(id, data) {
  const url = UPDATE_ORGANIZER_PROFILE.replace('{organizerProfileId}', id);
  const token = localStorage.getItem('token');

  const status = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else if (res.status === 400) {
        return res.json();
      }
      throw new Error('Error updating organizer');
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      //console.error(err);
    });

  return status;
}
